module.exports = __webpack_public_path__ + "img/right_bump.a86e4102.jpg";